import React, { Component } from 'react';
import { Divider, HTMLTable, Button, Intent, ButtonGroup } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class Ranks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 'LEVEL',
      levelRanks: [
        { rank: 1, player: 'Nozich', level: 110, guild: 'SROFilter_Guild', points: '14,890,200 EXP' },
        { rank: 2, player: 'Merlin', level: 110, guild: 'Asylum', points: '14,210,000 EXP' },
        { rank: 3, player: 'edjka1985', level: 110, guild: 'TwitchArmy', points: '13,950,400 EXP' },
        { rank: 4, player: 'Asviix', level: 110, guild: 'Asylum', points: '13,800,000 EXP' },
        { rank: 5, player: 'HandOfGod', level: 110, guild: 'GM_Staff', points: '13,500,000 EXP' },
      ],
      uniqueRanks: [
        { rank: 1, player: 'Merlin', kills: 184, points: '9,200 Unique Points', lastKill: 'Tiger Girl (3h ago)' },
        { rank: 2, player: 'Nozich', kills: 142, points: '7,100 Unique Points', lastKill: 'Demon Shaitan (2h ago)' },
        { rank: 3, player: 'FR_Henry', kills: 98, points: '4,900 Unique Points', lastKill: 'Captain Ivy (35m ago)' },
        { rank: 4, player: 'edjka1985', kills: 86, points: '4,300 Unique Points', lastKill: 'Uruchi (4m ago)' },
        { rank: 5, player: 'Asviix', kills: 74, points: '3,700 Unique Points', lastKill: 'Isyutaru (30m ago)' },
      ]
    };
  }

  render() {
    return (
      <SideMenuWrapper>
        <h3 className="display-4 font-italic mb-3" style={{ fontSize: '1.5rem', color: '#182026' }}>
          Server Hall of Fame & Leaderboards
        </h3>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Top Level, Unique Killers, Honor Points, and Job Leaderboards updated live.
        </p>

        <Divider className="mb-4" />

        <div className="d-flex mb-3 gap-2">
          <ButtonGroup>
            <Button active={this.state.tab === 'LEVEL'} onClick={() => this.setState({ tab: 'LEVEL' })} intent={Intent.PRIMARY} small>
              Top Player Level
            </Button>
            <Button active={this.state.tab === 'UNIQUE'} onClick={() => this.setState({ tab: 'UNIQUE' })} intent={Intent.WARNING} small>
              Top Unique Killers
            </Button>
          </ButtonGroup>
        </div>

        {this.state.tab === 'LEVEL' ? (
          <HTMLTable bordered condensed striped interactive style={{ width: '100%', fontSize: '0.82rem' }}>
            <thead>
              <tr>
                <th style={{ color: '#182026' }}>Rank</th>
                <th style={{ color: '#182026' }}>Character Name</th>
                <th style={{ color: '#182026' }}>Level Cap</th>
                <th style={{ color: '#182026' }}>Guild</th>
                <th style={{ color: '#182026' }}>Total EXP</th>
              </tr>
            </thead>
            <tbody>
              {this.state.levelRanks.map((r, i) => (
                <tr key={i}>
                  <td className="font-weight-bold" style={{ color: '#5c7080' }}>#{r.rank}</td>
                  <td className="font-weight-bold" style={{ color: '#106ba3' }}>{r.player}</td>
                  <td className="text-warning font-weight-bold">Lv. {r.level}</td>
                  <td style={{ color: '#182026' }}>{r.guild}</td>
                  <td className="font-mono text-success">{r.points}</td>
                </tr>
              ))}
            </tbody>
          </HTMLTable>
        ) : (
          <HTMLTable bordered condensed striped interactive style={{ width: '100%', fontSize: '0.82rem' }}>
            <thead>
              <tr>
                <th style={{ color: '#182026' }}>Rank</th>
                <th style={{ color: '#182026' }}>Player Killer</th>
                <th style={{ color: '#182026' }}>Uniques Slain</th>
                <th style={{ color: '#182026' }}>Unique Score</th>
                <th style={{ color: '#182026' }}>Recent Kill</th>
              </tr>
            </thead>
            <tbody>
              {this.state.uniqueRanks.map((r, i) => (
                <tr key={i}>
                  <td className="font-weight-bold" style={{ color: '#5c7080' }}>#{r.rank}</td>
                  <td className="font-weight-bold" style={{ color: '#106ba3' }}>{r.player}</td>
                  <td className="text-danger font-weight-bold">{r.kills} Uniques</td>
                  <td className="font-mono text-warning">{r.points}</td>
                  <td style={{ color: '#5c7080' }}>{r.lastKill}</td>
                </tr>
              ))}
            </tbody>
          </HTMLTable>
        )}
      </SideMenuWrapper>
    );
  }
}
